import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { NewHeaderComponent } from "../../shared/components/new-header/new-header.component";

/**
 * 404 Not Found 組件
 */
@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [TranslatePipe, MatButton, HeaderComponent, NewHeaderComponent],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  router: Router = inject(Router);

  // 返回首頁
  backToHome() {
    this.router.navigate(['/healthcheck']).then();
  }
}
